export enum ErrorCodes {
  FAILED_TO_FETCH = "FAILED_TO_FETCH",
  INVALID_RESPONSE_BODY = "INVALID_RESPONSE_BODY",
  INVALID_RESPONSE_HEADER = "INVALID_RESPONSE_HEADER",
  API_ERROR = "API_ERROR",
}
